import {
    RESEND_EMAIL,
    GET_LIST_MEMBERS,
    CREATE_MEMBER,
    DETAIL_LIST_MEMBER,
    GET_PROFILE_MEMBER,
    UPDATE_PROFILE_MEMBER,
    DELETE_MEMBER,
    UPDATE_STATUS_MEMBER,
    GET_LIST_ALL_MEMBERS,
    GET_LIST_USER_CHILDREN
} from '@/api/modules/member.api';

export default {
    get_list_members({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        GET_LIST_MEMBERS({ payload }, successCallback, errorCallback);
    },

    getListAllMembers({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        GET_LIST_ALL_MEMBERS({ payload }, successCallback, errorCallback);
    },

    getListAllChildren({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        GET_LIST_USER_CHILDREN({ payload }, successCallback, errorCallback);
    },

    createMember({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        CREATE_MEMBER({ payload }, successCallback, errorCallback);
    },
    getDetailMember({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        DETAIL_LIST_MEMBER({ payload }, successCallback, errorCallback);
    },
    delete_member({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        DELETE_MEMBER({ payload }, successCallback, errorCallback);
    },
    update_status_member({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        UPDATE_STATUS_MEMBER({ payload }, successCallback, errorCallback);
    },
    getProfileMember({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        GET_PROFILE_MEMBER({ payload }, successCallback, errorCallback);
    },

    updateProfileMember({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        UPDATE_PROFILE_MEMBER({ payload }, successCallback, errorCallback);
    },

    resendEmail({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        RESEND_EMAIL({ payload }, successCallback, errorCallback);
    }
};
